import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.scss'
import './styles/elementTheme/index.css'
import Plugins from './utils'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import i18n from './utils/language'

// 引入Vant配置
import './plugins/vant'
// 引入Vant样式
import 'vant/lib/index.css'

Vue.use(Plugins)
Vue.use(PerfectScrollbar)

Vue.use(ELEMENT, {
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
